function fromShopify(products) {
  return products.map(p => ({ title:p.title, handle:p.handle, type:p.product_type, vendor:p.vendor, tags:p.tags,
    price:(p.variants[0] || {}).price, compare:(p.variants[0] || {}).compare_at_price, vid:(p.variants.find(v => v.available) || p.variants[0] || {}).id,
    avail:p.variants.some(v => v.available) ? 1 : 0, img:(p.images[0] || {}).src || "" }));
}

// ---------- canvas + camera ----------
const cv = document.getElementById("ws-c"), ctx = cv.getContext("2d");
const wsWrap = document.getElementById("itt-walk-store");
let W, H, DPR;
function resize() { DPR = Math.min(2, devicePixelRatio || 1); W = wsWrap.clientWidth; H = wsWrap.clientHeight; cv.width = W * DPR; cv.height = H * DPR; ctx.setTransform(DPR, 0, 0, DPR, 0, 0); }
addEventListener("resize", resize); resize();
const cam = { x:0, tx:0, h:5.2, d:11.5, look:1.1 };
let CF, CU, CP;
function setupCam() {
  const narrow = W < 700;
  cam.d = narrow ? 12.5 : 12.5; cam.h = narrow ? 5.6 : 5.6;
  CP = [cam.x, cam.h, cam.d + 0.5];
  const t = [cam.x, cam.look, -0.8];
  let f = [t[0] - CP[0], t[1] - CP[1], t[2] - CP[2]]; const L = Math.hypot(...f); f = f.map(v => v / L);
  CF = f; CU = [0, -f[2], f[1]]; // up perpendicular to forward in the y-z plane (right = +x)
  const ul = Math.hypot(...CU); CU = CU.map(v => v / ul);
}
function P3(x, y, z) {
  const v = [x - CP[0], y - CP[1], z - CP[2]];
  const depth = v[0] * CF[0] + v[1] * CF[1] + v[2] * CF[2];
  const sx = v[0], sy = v[0] * CU[0] + v[1] * CU[1] + v[2] * CU[2];
  const f = Math.min(Math.max(W * 1.7, Math.min(W, H * 1.15)), H * 1.15) * 1.05;
  return [W / 2 + sx * f / depth, H * 0.5 - sy * f / depth, depth, f / depth];
}
function poly(pts, fill, stroke) { ctx.beginPath(); pts.forEach((p, i) => i ? ctx.lineTo(p[0], p[1]) : ctx.moveTo(p[0], p[1])); ctx.closePath(); if (fill) { ctx.fillStyle = fill; ctx.fill(); } if (stroke) { ctx.strokeStyle = stroke; ctx.stroke(); } }
const rgba = (c, a) => `rgba(${c[0]},${c[1]},${c[2]},${a})`;
const shade = (c, k) => `rgb(${Math.round(c[0] * k)},${Math.round(c[1] * k)},${Math.round(c[2] * k)})`;
function rnd(seed) { let s = seed; return () => (s = (s * 16807) % 2147483647) / 2147483647; }

// ---------- character (MotionBricks walk cycle) ----------
const me = { x:0, z:0.4, face:-Math.PI / 2, phase:0, walkW:0, path:[], target:null, inside:null, arriving:null };
function lerp(a, b, t) { return a + (b - a) * t; }
function cyclePose(ph) { const f = ((ph % N) + N) % N, i = Math.floor(f), t = f - i, A = D.cycle[i], B = D.cycle[(i + 1) % N]; return A.map((p, j) => [lerp(p[0], B[j][0], t), lerp(p[1], B[j][1], t), lerp(p[2], B[j][2], t)]); }
function mixPose(a, b, t) { return a.map((p, j) => [lerp(p[0], b[j][0], t), lerp(p[1], b[j][1], t), lerp(p[2], b[j][2], t)]); }
function placePose(pose, x, z, face, bob = 0) {
  const c = Math.cos(face), s = Math.sin(face);
  return pose.map(p => [x + p[0] * c - p[2] * s, p[1] + bob, z + p[0] * s + p[2] * c]);
}
function goTo(key) {
  const r = ROOMS.find(r => r.key === key); if (!r) return;
  if (me.inside) exitRoom(false);
  me.path = [[r.x, 0.6], [r.x, FRONT + 0.55]]; me.arriving = key; setDial(key);
}
function walkFree(dir) { if (me.inside) return; me.arriving = null; me.path = [[Math.max(-18, Math.min(18, me.x + dir * 2.2)), Math.max(0.2, Math.min(1.6, me.z))]]; }

// ---------- drawing ----------
function drawSky() {
  const g = ctx.createLinearGradient(0, 0, 0, H); g.addColorStop(0, "#0b0e1c"); g.addColorStop(0.55, "#111427"); g.addColorStop(1, "#06070b");
  ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
  // distant skyline
  const r = rnd(7); ctx.fillStyle = "rgba(30,34,58,.55)";
  for (let i = 0; i < 40; i++) { const bx = -60 + i * 3.2 + r() * 2, bh = 6 + r() * 14; const a = P3(bx, 0, -26), b = P3(bx + 2.6, bh, -26); ctx.fillRect(a[0], b[1], b[0] - a[0], a[1] - b[1]); }
}
function drawGround(t) {
  // sidewalk + road
  const q = (x0, z0, x1, z1) => [P3(x0, 0, z0), P3(x1, 0, z0), P3(x1, 0, z1), P3(x0, 0, z1)];
  poly(q(-40, -12, 40, FRONT), "#0f1220");
  poly(q(-40, FRONT, 40, -1.2), "#1a1e2d");
  poly(q(-40, -1.2, 40, 6), "#111420");
  // curb line
  ctx.strokeStyle = "rgba(226,189,98,.18)"; ctx.lineWidth = 1.5; ctx.beginPath(); const c0 = P3(-40, 0, -1.2), c1 = P3(40, 0, -1.2); ctx.moveTo(c0[0], c0[1]); ctx.lineTo(c1[0], c1[1]); ctx.stroke();
  // lane dashes (scroll with camera for life)
  ctx.fillStyle = "rgba(239,233,220,.14)";
  for (let x = Math.floor(cam.x / 3) * 3 - 24; x < cam.x + 24; x += 3) poly(q(x, 2.3, x + 1.4, 2.45), "rgba(239,233,220,.13)");
  // light pools under lamps
  for (let i = 0; i < ROOMS.length + 1; i++) {
    const lx = (i - ROOMS.length / 2) * WS_GAP, p = P3(lx, 0, -0.7);
    const g = ctx.createRadialGradient(p[0], p[1], 0, p[0], p[1], p[3] * 3.2);
    g.addColorStop(0, "rgba(255,214,150,.13)"); g.addColorStop(1, "rgba(255,214,150,0)");
    ctx.fillStyle = g; ctx.beginPath(); ctx.ellipse(p[0], p[1], p[3] * 3.2, p[3] * 1.1, 0, 0, 7); ctx.fill();
  }
}
function drawBuilding(r, t, hot) {
  const x0 = r.x - WIDTH / 2, x1 = r.x + WIDTH / 2, z0 = FRONT - DEPTH, z1 = FRONT, h = r.h, c = r.color;
  const A = P3(x0, 0, z1), B = P3(x1, 0, z1), C = P3(x1, h, z1), Dp = P3(x0, h, z1);
  const A2 = P3(x0, 0, z0), B2 = P3(x1, 0, z0), C2 = P3(x1, h, z0), D2 = P3(x0, h, z0);
  const base = [26, 29, 44];
  // side faces
  if (CP[0] < x0) poly([A, Dp, D2, A2], shade(base, .8));
  if (CP[0] > x1) poly([B, C, C2, B2], shade(base, .8));
  // roof
  poly([Dp, C, C2, D2], shade(base, 1.25));
  ctx.strokeStyle = rgba(c, .55); ctx.lineWidth = 1.2; poly([Dp, C, C2, D2], null, rgba(c, .5));
  // front
  const fg = ctx.createLinearGradient(0, Dp[1], 0, A[1]); fg.addColorStop(0, shade(base, 1.05)); fg.addColorStop(1, shade(base, .7));
  poly([A, B, C, Dp], fg);
  // windows
  const rr = rnd(r.seed); const cols = 4, rows = Math.floor((h - 2.4) / 1.05);
  for (let j = 0; j < rows; j++) for (let i = 0; i < cols; i++) {
    const wx = x0 + 0.45 + i * ((WIDTH - 0.9) / cols), wy = 2.5 + j * 1.05, lit = rr() > 0.38, flick = lit && rr() > 0.92 ? (Math.sin(t * 3 + i + j) > 0.6 ? .35 : 1) : 1;
    const q = [P3(wx + .12, wy, z1 + .01), P3(wx + (WIDTH - 0.9) / cols - .12, wy, z1 + .01), P3(wx + (WIDTH - 0.9) / cols - .12, wy + .62, z1 + .01), P3(wx + .12, wy + .62, z1 + .01)];
    poly(q, lit ? rgba(c, (.28 + rr() * .35) * flick) : "rgba(10,12,20,.8)");
  }
  // door
  const dg = hot ? 1 : .55 + .1 * Math.sin(t * 2 + r.seed);
  const d = [P3(r.x - .6, 0, z1 + .02), P3(r.x + .6, 0, z1 + .02), P3(r.x + .6, 2.1, z1 + .02), P3(r.x - .6, 2.1, z1 + .02)];
  ctx.save(); ctx.shadowColor = rgba(c, .9); ctx.shadowBlur = (hot ? 34 : 16) * (d[0][3] / 60); poly(d, rgba(c, .32 * dg + .1)); ctx.restore();
  poly(d, null, rgba(c, .85 * dg));
  // door light spill on sidewalk
  const sp = P3(r.x, 0, z1 + 0.8), g = ctx.createRadialGradient(sp[0], sp[1], 0, sp[0], sp[1], sp[3] * 1.6);
  g.addColorStop(0, rgba(c, hot ? .28 : .12)); g.addColorStop(1, rgba(c, 0)); ctx.fillStyle = g; ctx.beginPath(); ctx.ellipse(sp[0], sp[1], sp[3] * 1.8, sp[3] * .55, 0, 0, 7); ctx.fill();
  // neon sign
  const s = P3(r.x, 2.55 + Math.min(1.6, (h - 3) * .25), z1 + .05), size = Math.max(9, s[3] * .42);
  ctx.save(); ctx.font = `800 ${size}px -apple-system,system-ui,sans-serif`; ctx.textAlign = "center"; ctx.textBaseline = "middle";
  const on = hot || Math.sin(t * 7 + r.seed) > -0.97;
  ctx.shadowColor = rgba(c, 1); ctx.shadowBlur = on ? size * (hot ? 1.4 : .9) : 0; ctx.fillStyle = on ? rgba(c, 1) : rgba(c, .35);
  ctx.fillText(r.short, s[0], s[1]); ctx.restore();
  r._hit = [A, B, C, Dp];
}
function drawLamp(x, t) {
  const b = P3(x, 0, -1.0), top = P3(x, 3.6, -1.0);
  ctx.strokeStyle = "#2a2f42"; ctx.lineWidth = Math.max(1.5, b[3] * .07); ctx.beginPath(); ctx.moveTo(b[0], b[1]); ctx.lineTo(top[0], top[1]); ctx.stroke();
  const g = ctx.createRadialGradient(top[0], top[1], 0, top[0], top[1], top[3] * 1.2);
  g.addColorStop(0, "rgba(255,226,170,.95)"); g.addColorStop(.18, "rgba(255,214,150,.45)"); g.addColorStop(1, "rgba(255,214,150,0)");
  ctx.fillStyle = g; ctx.beginPath(); ctx.arc(top[0], top[1], top[3] * 1.2, 0, 7); ctx.fill();
}
function drawFigure(pts, color, label, glow, lift = 0) {
  // ground shadow
  const hp = pts[0], sh = P3(hp[0], 0, hp[2]);
  ctx.fillStyle = "rgba(0,0,0,.45)"; ctx.beginPath(); ctx.ellipse(sh[0], sh[1], sh[3] * .38, sh[3] * .1, 0, 0, 7); ctx.fill();
  const pr = pts.map(p => P3(p[0], p[1], p[2])); const segs = [];
  for (let j = 0; j < J.length; j++) {
    if (P[j] < 0 || /Eye|Jaw|ThumbEnd|MiddleEnd/.test(J[j])) continue;
    const n = J[j], w = /Shin|Leg/.test(n) ? .085 : /Foot|Toe/.test(n) ? .055 : /ForeArm|Hand/.test(n) ? .05 : /Arm|Shoulder/.test(n) ? .068 : /Neck/.test(n) ? .055 : .12;
    segs.push([pr[j], pr[P[j]], w, (pr[j][2] + pr[P[j]][2]) / 2]);
  }
  segs.sort((a, b) => b[3] - a[3]);
  if (glow) { ctx.save(); ctx.shadowColor = rgba(color, .55); ctx.shadowBlur = 18; }
  for (const [a, b, w, dz] of segs) {
    const k = Math.max(.55, Math.min(1.05, 1.25 - (dz - pr[0][2]) * .9));
    ctx.strokeStyle = shade(color, k); ctx.lineWidth = w * a[3]; ctx.lineCap = "round";
    ctx.beginPath(); ctx.moveTo(a[0], a[1]); ctx.lineTo(b[0], b[1]); ctx.stroke();
  }
  const hd = P3(pts[HEAD][0], pts[HEAD][1] + .07, pts[HEAD][2]);
  ctx.fillStyle = shade(color, 1.05); ctx.beginPath(); ctx.arc(hd[0], hd[1], hd[3] * .12, 0, 7); ctx.fill();
  if (glow) ctx.restore();
  if (label) {
    const lp = P3(pts[HEAD][0], pts[HEAD][1] + .42 + lift, pts[HEAD][2]), fs = Math.max(10, Math.min(14, lp[3] * .2));
    ctx.font = `700 ${fs}px -apple-system,system-ui,sans-serif`; ctx.textAlign = "center";
    const tw = ctx.measureText(label).width + 12;
    ctx.fillStyle = "rgba(8,10,16,.75)"; ctx.beginPath(); ctx.roundRect ? ctx.roundRect(lp[0] - tw / 2, lp[1] - fs - 2, tw, fs + 8, 6) : ctx.rect(lp[0] - tw / 2, lp[1] - fs - 2, tw, fs + 8); ctx.fill();
    ctx.fillStyle = rgba(color, 1); ctx.fillText(label, lp[0], lp[1] + 1);
  }
}



// shoppers walking the street (same MotionBricks walk cycle)
const NPC = [0, 1, 2].map(i => ({ x:(i - 1) * 9, z:1.1 + i * .35, face:0, phase:i * 11, dir:i % 2 ? -1 : 1, color:[[150,200,255],[255,160,200],[150,230,180]][i], speed:1.25 + i * .12 }));

// ---------- player look: driven by the Character Creator ----------
// Reads the creator's saved outfit (localStorage "itt-creator-v2-selection", same browser on ittoldem.com),
// or an outfit posted in by a parent page (iframe bridge), or a "Wear" pick made in this street.
const LOOK = { top:null, pants:null, topColor:null, pantsColor:null, sig:"" };
let BRIDGE = null;
function hsl(h, s, l) { const k = n => (n + h / 30) % 12, a = s * Math.min(l, 1 - l), f = n => l - a * Math.max(-1, Math.min(k(n) - 3, 9 - k(n), 1)); return [f(0), f(8), f(4)].map(v => Math.round(v * 255)); }
function hashColor(str) { let h = 0; for (const c of str) h = (h * 31 + c.charCodeAt(0)) | 0; return hsl(Math.abs(h) % 360, .42, .5); }
// Exact garment tones for the Character Creator's panel items (handle -> tone), copied from the
// creator's own garment manifest (median colour sampled from each garment's part-art). These win
// over the handle hash and over photo sampling, so a black garment renders black — Oct 31, 2026.
const TONES = { "rich-friends-hoodie":"#874A67", "custom-picture-hoodie":"#1D1B1A", "custom-design-t-shirt":"#1D1B1A", "football-family-fan-jersey-adult":"#403933", "girl-dad-flag-football-youth-panel-tee":"#202020", "itt-flagline-quarter-zip-pullover":"#1A1A1A", "cheer-mom-trust-the-bases-hoodie":"#D2C9BD", "itt-flagline-short":"#242323", "itt-flagline-compression-leggings":"#151515", "frog-skin-joggers":"#BEBAA5", "itt-told-em-engraved-denim-third-edition":"#56738D", "itt-told-em-custom-khaki-design":"#B89F84", "itt-toldem-no-00-rich-friends-jogger":"#9F9EA2" };
function toneRGB(h) { const t = h && TONES[h]; if (!t) return null; const n = parseInt(t.slice(1), 16); return [(n >> 16) & 255, (n >> 8) & 255, n & 255]; }
function findByHandle(h) { for (const r of ROOMS) { const p = r.items.find(p => p.handle === h); if (p) return p; } return null; }
function sampleColor(p, cb) {
  if (!p || !p.img) return cb(null);
  const im = new Image(); im.crossOrigin = "anonymous";
  im.onload = () => { try { const c = document.createElement("canvas"); c.width = c.height = 24; const x = c.getContext("2d"); x.drawImage(im, 0, 0, 24, 24);
    const d = x.getImageData(0, 0, 24, 24).data; let r = 0, g = 0, b = 0, n = 0;
    for (let i = 0; i < d.length; i += 4) { const R = d[i], G = d[i + 1], B = d[i + 2]; if (d[i + 3] < 200) continue; const mx = Math.max(R, G, B), mn = Math.min(R, G, B); if (mn > 222 || (mx - mn < 10 && mx > 200)) continue; r += R; g += G; b += B; n++; }
    cb(n > 12 ? [r / n, g / n, b / n].map(Math.round) : null); } catch (e) { cb(null); } };
  im.onerror = () => cb(null); im.src = imgURL(p).replace("width=360", "width=64");
}
function readJSON(k) { try { return JSON.parse(localStorage.getItem(k) || "null"); } catch (e) { return null; } }
function readLook(force) {
  const rec = readJSON("itt-creator-v2-selection"), wear = readJSON("itt-walk-outfit") || {}, man = rec && rec.visualAssetManifest;
  const top = wear.top || (BRIDGE && BRIDGE.top) || (man && man.top && man.top.handle) || null;
  const pants = wear.pants || (BRIDGE && BRIDGE.pants) || (man && man.pants && man.pants.handle) || null;
  const sig = top + "|" + pants; if (sig === LOOK.sig && !force) return; LOOK.sig = sig; LOOK.top = top; LOOK.pants = pants;
  LOOK.topColor = toneRGB(top) || (top ? hashColor(top) : null);
  LOOK.pantsColor = toneRGB(pants) || (pants ? hashColor(pants) : null);
  const tp = top && findByHandle(top), pp = pants && findByHandle(pants);
  if (!toneRGB(top)) sampleColor(tp, c => { if (c && LOOK.top === top) { LOOK.topColor = c; showLook(); } });
  if (!toneRGB(pants)) sampleColor(pp, c => { if (c && LOOK.pants === pants) { LOOK.pantsColor = c; showLook(); } });
  showLook(); if (me.inside) renderGrid();
}
function showLook() {
  const el = document.getElementById("ws-look"), name = h => { const p = h && findByHandle(h); return p ? p.title.split(" — ")[0] : null; };
  const parts = [[LOOK.top, LOOK.topColor], [LOOK.pants, LOOK.pantsColor]].filter(x => x[0]).map(([h, c]) => `<i style="background:${rgba(c || [200,200,200], 1)}"></i>${esc(name(h) || h)}`);
  el.style.display = parts.length ? "block" : "none"; el.innerHTML = parts.length ? "Wearing" + parts.join("") : "";
}
function wearItem(p, roomKey) {
  const slot = roomKey === "bottoms" ? "pants" : "top", w = readJSON("itt-walk-outfit") || {};
  w[slot] = w[slot] === p.handle ? null : p.handle;
  try { localStorage.setItem("itt-walk-outfit", JSON.stringify(w)); } catch (e) {}
  const detail = { slot, handle: w[slot], variantId: p.vid };
  dispatchEvent(new CustomEvent("itt:walk-wear", { detail }));
  try { if (parent !== window) parent.postMessage({ type: "itt:walk-wear", ...detail }, "*"); } catch (e) {}
  readLook(true);
}
addEventListener("storage", () => readLook());
addEventListener("itt:player-update", () => readLook(true));
addEventListener("message", e => {
  if (!/^https:\/\/([a-z0-9-]+\.)?ittoldem\.com$/.test(e.origin) || !e.data || e.data.type !== "itt:player") return;
  BRIDGE = { top: e.data.top || null, pants: e.data.pants || null }; readLook(true);
});
setInterval(() => readLook(), 1500);
const SKIN = [236, 214, 190], SHOE = [38, 40, 50];
function partColor(name) {
  if (/Leg|Shin/.test(name)) return LOOK.pantsColor || [244,238,226];
  if (/Foot|Toe/.test(name)) return LOOK.pantsColor ? SHOE : [244,238,226];
  if (/Spine|Chest|Shoulder|LeftArm$|RightArm$|ForeArm/.test(name)) return LOOK.topColor || [244,238,226];
  return LOOK.topColor || LOOK.pantsColor ? SKIN : [244,238,226];
}
function drawPlayer(pts) {
  const hp = pts[0], sh = P3(hp[0], 0, hp[2]);
  ctx.fillStyle = "rgba(0,0,0,.45)"; ctx.beginPath(); ctx.ellipse(sh[0], sh[1], sh[3] * .38, sh[3] * .1, 0, 0, 7); ctx.fill();
  const pr = pts.map(p => P3(p[0], p[1], p[2])), segs = [];
  for (let j = 0; j < J.length; j++) {
    if (P[j] < 0 || /Eye|Jaw|ThumbEnd|MiddleEnd/.test(J[j])) continue;
    const n = J[j], w = /Shin|Leg/.test(n) ? .09 : /Foot|Toe/.test(n) ? .06 : /ForeArm|Hand/.test(n) ? .055 : /Arm|Shoulder/.test(n) ? .075 : /Neck/.test(n) ? .055 : .14;
    segs.push([pr[j], pr[P[j]], w, (pr[j][2] + pr[P[j]][2]) / 2, partColor(n)]);
  }
  segs.sort((a, b) => b[3] - a[3]);
  ctx.save(); ctx.shadowColor = rgba(LOOK.topColor || [244,238,226], .5); ctx.shadowBlur = 18;
  for (const [a, b, w, dz, col] of segs) { const k = Math.max(.55, Math.min(1.08, 1.25 - (dz - pr[0][2]) * .9)); ctx.strokeStyle = shade(col, k); ctx.lineWidth = w * a[3]; ctx.lineCap = "round"; ctx.beginPath(); ctx.moveTo(a[0], a[1]); ctx.lineTo(b[0], b[1]); ctx.stroke(); }
  const hd = P3(pts[HEAD][0], pts[HEAD][1] + .07, pts[HEAD][2]); ctx.fillStyle = shade(LOOK.topColor || LOOK.pantsColor ? SKIN : [244,238,226], 1.02); ctx.beginPath(); ctx.arc(hd[0], hd[1], hd[3] * .12, 0, 7); ctx.fill();
  ctx.restore();
  const lp = P3(pts[HEAD][0], pts[HEAD][1] + .42, pts[HEAD][2]), fs = Math.max(10, Math.min(14, lp[3] * .2));
  ctx.font = `700 ${fs}px -apple-system,system-ui,sans-serif`; ctx.textAlign = "center"; const tw = ctx.measureText("You").width + 12;
  ctx.fillStyle = "rgba(8,10,16,.75)"; ctx.beginPath(); ctx.roundRect ? ctx.roundRect(lp[0] - tw / 2, lp[1] - fs - 2, tw, fs + 8, 6) : ctx.rect(lp[0] - tw / 2, lp[1] - fs - 2, tw, fs + 8); ctx.fill();
  ctx.fillStyle = "#efe9dc"; ctx.fillText("You", lp[0], lp[1] + 1);
}

// ---------- loop ----------
let last = performance.now(), hotKey = "tops";
const HALF = ((ROOMS.length - 1) / 2) * WS_GAP + 3;
function frame(now) {
  const dt = Math.min(.05, (now - last) / 1000), t = now / 1000; last = now;
  let moving = false;
  if (me.path.length) {
    const [tx, tz] = me.path[0], dx = tx - me.x, dz = tz - me.z, dist = Math.hypot(dx, dz);
    const speed = 1.6 * (me.walkW * .7 + .3), step = Math.min(dist, speed * dt);
    if (dist > .02) {
      const want = Math.atan2(dz, dx); let dA = Math.atan2(Math.sin(want - me.face), Math.cos(want - me.face));
      me.face += dA * Math.min(1, dt * 9);
      const go = Math.abs(dA) < 1.2 ? step : step * .25;
      me.x += Math.cos(me.face) * go; me.z += Math.sin(me.face) * go;
      me.phase += go / D.stride * N; moving = true;
    }
    if (dist < .06) { me.path.shift(); if (!me.path.length && me.arriving) enterRoom(me.arriving); }
  }
  me.walkW = lerp(me.walkW, moving ? 1 : 0, Math.min(1, dt * (moving ? 8 : 5)));
  if (!moving && !me.inside && !me.path.length && me.arriving === null) { const dA = Math.atan2(Math.sin(Math.PI / 2 - me.face), Math.cos(Math.PI / 2 - me.face)); me.face += dA * Math.min(1, dt * 3); }
  NPC.forEach(n => { const go = n.speed * dt; n.x += n.dir * go; n.phase += go / D.stride * N; n.face = n.dir > 0 ? 0 : Math.PI; if (Math.abs(n.x) > HALF) n.dir *= -1; });
  cam.x = lerp(cam.x, me.x, Math.min(1, dt * 2.2)); setupCam();

  drawSky(); drawGround(t);
  const order = [...ROOMS].sort((a, b) => Math.abs(b.x - CP[0]) - Math.abs(a.x - CP[0]));
  for (const r of order) { drawBuilding(r, t, r.key === hotKey); drawCount(r); }
  const actors = [];
  for (let i = 0; i < ROOMS.length + 1; i++) { const lx = (i - ROOMS.length / 2) * WS_GAP; actors.push({ z:-1.0, draw:() => drawLamp(lx, t) }); }
  NPC.forEach(n => actors.push({ z:n.z, draw:() => drawFigure(placePose(cyclePose(n.phase), n.x, n.z, n.face), n.color.map(c => c * .8), null, false) }));
  if (!me.inside) actors.push({ z:me.z, draw:() => drawPlayer(placePose(mixPose(D.stand, cyclePose(me.phase), me.walkW), me.x, me.z, me.face)) });
  actors.sort((a, b) => a.z - b.z); actors.forEach(a => a.draw());
  const v = ctx.createRadialGradient(W / 2, H * .55, Math.min(W, H) * .3, W / 2, H * .55, Math.max(W, H) * .8);
  v.addColorStop(0, "rgba(0,0,0,0)"); v.addColorStop(1, "rgba(0,0,0,.55)"); ctx.fillStyle = v; ctx.fillRect(0, 0, W, H);
  requestAnimationFrame(frame);
}
function drawCount(r) {
  const s = P3(r.x, 2.55 + Math.min(1.6, (r.h - 3) * .25) - .55, FRONT + .05), size = Math.max(8, s[3] * .2);
  ctx.font = `600 ${size}px -apple-system,system-ui,sans-serif`; ctx.textAlign = "center"; ctx.fillStyle = rgba(r.color, .8);
  ctx.fillText(r.items.length + (r.items.length === 1 ? " item" : " items"), s[0], s[1]);
}

// ---------- input ----------
function inPoly(x, y, p) { let c = false; for (let i = 0, j = p.length - 1; i < p.length; j = i++) if ((p[i][1] > y) !== (p[j][1] > y) && x < (p[j][0] - p[i][0]) * (y - p[i][1]) / (p[j][1] - p[i][1]) + p[i][0]) c = !c; return c; }
cv.addEventListener("pointerup", e => { if (me.inside) return; for (const r of ROOMS) if (r._hit && inPoly(e.clientX - cv.getBoundingClientRect().left, e.clientY - cv.getBoundingClientRect().top, r._hit)) { goTo(r.key); return; } });
function step(d) { const i = ROOMS.findIndex(r => r.key === hotKey); setDial(ROOMS[(i + d + ROOMS.length) % ROOMS.length].key); }
addEventListener("keydown", e => {
  if (e.target.tagName === "INPUT") { if (e.key === "Escape") exitRoom(true); return; }
  if (e.key === "Escape") return exitRoom(true);
  if (me.inside) return;
  if (e.key === "ArrowRight") step(1); if (e.key === "ArrowLeft") step(-1);
  if (e.key === "Enter" || e.key === "ArrowUp") goTo(hotKey);
});

// ---------- radio tuner ----------
const strip = document.getElementById("ws-strip"), band = document.getElementById("ws-band"), STN_W = 104;
function buildTuner() {
  strip.innerHTML = ROOMS.map(r => `<div class="stn" data-k="${r.key}" role="button" tabindex="0" aria-label="${r.name}, ${r.items.length} items">${r.short}<small>${r.items.length}</small></div>`).join("");
  strip.querySelectorAll("#itt-walk-store .stn").forEach(el => { el.onclick = () => { if (!dragMoved) goTo(el.dataset.k); }; el.onkeydown = e => { if (e.key === "Enter" || e.key === " ") goTo(el.dataset.k); }; });
  setDial(hotKey);
}
function stripX(i) { return band.clientWidth / 2 - (i + .5) * STN_W; }
function setDial(key) {
  hotKey = key; const i = ROOMS.findIndex(r => r.key === key);
  strip.style.transform = `translateX(${stripX(i)}px)`;
  document.getElementById("ws-nowTxt").textContent = ROOMS[i].name;
  strip.querySelectorAll("#itt-walk-store .stn").forEach(el => el.classList.toggle("on", el.dataset.k === key));
}
let dragX = null, dragBase = 0, dragMoved = false;
band.addEventListener("pointerdown", e => { dragX = e.clientX; dragMoved = false; dragBase = stripX(ROOMS.findIndex(r => r.key === hotKey)); strip.classList.add("drag"); });
addEventListener("pointermove", e => { if (dragX === null) return; const dx = e.clientX - dragX; if (Math.abs(dx) > 6) dragMoved = true; strip.style.transform = `translateX(${dragBase + dx}px)`;
  const i = Math.max(0, Math.min(ROOMS.length - 1, Math.round((band.clientWidth / 2 - (dragBase + dx)) / STN_W - .5))); if (ROOMS[i].key !== hotKey) { hotKey = ROOMS[i].key; document.getElementById("ws-nowTxt").textContent = ROOMS[i].name; strip.querySelectorAll("#itt-walk-store .stn").forEach(el => el.classList.toggle("on", el.dataset.k === hotKey)); } });
addEventListener("pointerup", () => { if (dragX === null) return; dragX = null; strip.classList.remove("drag"); setDial(hotKey); setTimeout(() => dragMoved = false, 0); });
document.getElementById("ws-prev").onclick = () => step(-1);
document.getElementById("ws-next").onclick = () => step(1);
document.getElementById("ws-go").onclick = () => goTo(hotKey);
addEventListener("resize", () => setDial(hotKey));

// ---------- shop rooms ----------
const room = document.getElementById("ws-room"), fade = document.getElementById("ws-fade"), grid = document.getElementById("ws-grid"), q = document.getElementById("ws-q");
/* named wsMoney, not money: the Character Creator section above declares a page-global
   const money of its own, and a duplicate top-level const in this file stopped the whole
   script from executing (dead canvas, dead tuner) — fixed Oct 31, 2026. */
const wsMoney = v => { const n = Number(v); return isFinite(n) ? "$" + (n % 1 ? n.toFixed(2) : n.toLocaleString()) : ""; };
const esc = s => String(s).replace(/[&<>"']/g, c => ({ "&":"&amp;", "<":"&lt;", ">":"&gt;", '"':"&quot;", "'":"&#39;" }[c]));
function imgURL(p) { const src = p.img.startsWith("http") ? p.img : IMG + p.img; return src + (src.includes("?") ? "&" : "?") + "width=360"; }
function renderGrid() {
  const r = ROOMS.find(r => r.key === me.inside); if (!r) return;
  const s = q.value.trim().toLowerCase(), wearable = r.key === "tops" || r.key === "bottoms", worn = h => h === LOOK.top || h === LOOK.pants;
  const base = s ? r.items.filter(p => p.title.toLowerCase().includes(s)) : r.items, list = [...base.filter(p => worn(p.handle)), ...base.filter(p => !worn(p.handle))];
  document.getElementById("ws-count").textContent = list.length + " of " + r.items.length;
  grid.innerHTML = list.length ? list.map(p => `<div class="card">
    <a class="img" target="_top" href="${SHOP}/products/${esc(p.handle)}" aria-label="${esc(p.title)}"><img loading="lazy" src="${esc(imgURL(p))}" alt="">${wearable ? `<button class="wear${worn(p.handle) ? " on" : ""}" data-h="${esc(p.handle)}">${worn(p.handle) ? "Wearing" : "Wear it"}</button>` : ""}</a>
    <div class="body"><div class="t">${esc(p.title)}</div><div class="p">${wsMoney(p.price)}${p.compare && Number(p.compare) > Number(p.price) ? `<s>${wsMoney(p.compare)}</s>` : ""}</div>
    <div class="row"><a target="_top" href="${SHOP}/products/${esc(p.handle)}">View</a><a target="_top" class="add${p.avail && p.vid ? "" : " off"}" href="${SHOP}/cart/add?id=${p.vid}&quantity=1">${p.avail ? "Add to bag" : "Sold out"}</a></div></div></div>`).join("")
    : `<div class="empty">Nothing here matches "${esc(s)}".</div>`;
  grid.scrollTop = 0;
  grid.querySelectorAll("#itt-walk-store .wear").forEach(b => b.onclick = e => { e.preventDefault(); e.stopPropagation(); const p = r.items.find(p => p.handle === b.dataset.h); if (p) wearItem(p, r.key); });
}
q.addEventListener("input", renderGrid);
function enterRoom(key) {
  const r = ROOMS.find(r => r.key === key); me.inside = key; me.arriving = null;
  document.getElementById("ws-rname").textContent = r.name; document.getElementById("ws-rdesc").textContent = r.desc;
  const sw = document.getElementById("ws-rsw"); sw.style.background = rgba(r.color, 1); sw.style.color = rgba(r.color, 1);
  q.value = ""; renderGrid();
  fade.classList.add("on"); room.classList.add("on"); document.getElementById("ws-tuner").style.opacity = ".2";
  try { sessionStorage.setItem("ittRoom", key); } catch {}
}
function exitRoom(walkOut) {
  if (!me.inside) return; const r = ROOMS.find(r => r.key === me.inside);
  me.inside = null; room.classList.remove("on"); fade.classList.remove("on"); document.getElementById("ws-tuner").style.opacity = "1";
  me.x = r.x; me.z = FRONT + .55; me.face = Math.PI / 2;
  if (walkOut) me.path = [[r.x, 0.7]];
  try { sessionStorage.removeItem("ittRoom"); } catch {}
}
document.getElementById("ws-leave").onclick = () => exitRoom(true);
document.getElementById("ws-nextRoom").onclick = () => { const i = ROOMS.findIndex(r => r.key === me.inside); exitRoom(false); goTo(ROOMS[(i + 1) % ROOMS.length].key); };

// ---------- start ----------
loadCatalog(SNAPSHOT);
(function startPosition() {
  let saved = null; try { saved = sessionStorage.getItem("ittRoom"); } catch {}
  const r = ROOMS.find(r => r.key === saved) || ROOMS[0];
  me.x = r.x; cam.x = r.x; setDial(r.key);
})();
if (/(^|\.)ittoldem\.com$/.test(location.hostname)) {
  fetch("/products.json?limit=250").then(r => r.json()).then(async d => {
    let all = d.products, page = 2;
    while (d.products.length === 250 && page < 6) { d = await (await fetch("/products.json?limit=250&page=" + page++)).json(); all = all.concat(d.products); }
    loadCatalog(fromShopify(all));
  }).catch(() => {});
}
requestAnimationFrame(frame);
